import { useEffect, useState } from 'react';

import get from 'lodash/get';
import useSWR from 'swr';

import { getVolumeConfigs } from '../api';
import type { ReclaimPolicyOptionItem } from '../types';
import { mapReclaimPolicyItems } from '../utils';

const SWR_KEY = { key: 'RECLAIM_POLICY_OPTIONS' };

export function useReclaimPolicyOptions(enabled = false) {
  const { data, error, isLoading } = useSWR(enabled ? SWR_KEY : null, () => getVolumeConfigs(), {
    revalidateOnFocus: false,
    refreshInterval: 10 * 60_000,
  });

  const [options, setOptions] = useState<ReclaimPolicyOptionItem[]>([]);

  useEffect(() => {
    if (!data) return;
    const policies = get(data, 'volume.reclaimPolicy', []) as string[];
    setOptions(mapReclaimPolicyItems(policies));
  }, [data]);

  return { options, isLoading, error, isReady: !isLoading };
}
